import type { CrewJobPayUnit } from './crewJobs';
import type { CandidatePipelineStepState, JobOfferSection, JobOfferSignature } from './hiring';

export type ContractorApplicantStatus =
  | 'submitted'
  | 'forms_requested'
  | 'forms_approved'
  | 'agreement_sent'
  | 'pooled'
  | 'declined';

export const CONTRACTOR_APPLICANT_STATUSES: ContractorApplicantStatus[] = [
  'submitted',
  'forms_requested',
  'forms_approved',
  'agreement_sent',
  'pooled',
  'declined',
];

export const CONTRACTOR_APPLICANT_STATUS_LABELS: Record<ContractorApplicantStatus, string> = {
  submitted: 'Submitted',
  forms_requested: 'Forms requested',
  forms_approved: 'Forms approved',
  agreement_sent: 'Agreement sent',
  pooled: 'In pool',
  declined: 'Declined',
};

export type ContractorOnboardStepId = 'submitted' | 'forms' | 'agreement' | 'pool';

export interface ContractorOnboardStep {
  id: ContractorOnboardStepId;
  label: string;
  state: CandidatePipelineStepState;
}

export interface ContractorApplicantFile {
  fileName: string;
  storagePath: string;
  contentType: string;
  sizeBytes: number;
  uploadedAt: Date;
}

export interface ContractorApplicant {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  emailNormalized: string;
  phone?: string;
  status: ContractorApplicantStatus;
  sourceCommitIds: string[];
  jobIds: string[];
  lastJobId?: string | null;
  lastJobTitle?: string | null;
  publicSlug: string;
  w9?: ContractorApplicantFile | null;
  photoId?: ContractorApplicantFile | null;
  w9ApprovedAt?: Date | null;
  w9ApprovedBy?: string | null;
  photoIdApprovedAt?: Date | null;
  photoIdApprovedBy?: string | null;
  formsRequestedAt?: Date | null;
  formsApprovedAt?: Date | null;
  agreementId?: string | null;
  contractorUserId?: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export type ContractorAgreementStatus = 'draft' | 'sent' | 'signed' | 'voided';

export interface ContractorAgreementFields {
  contractorFirstName: string;
  contractorLastName: string;
  contractorEmail: string;
  jobTitle: string;
  scope: string;
  payAmount: number;
  payUnit: CrewJobPayUnit;
  location: string;
  ceoName: string;
  ceoTitle: string;
}

export interface ContractorAgreement {
  id: string;
  applicantId: string;
  slug: string;
  status: ContractorAgreementStatus;
  fields: ContractorAgreementFields;
  sections: JobOfferSection[];
  ceoSignature: JobOfferSignature | null;
  contractorSignature: JobOfferSignature | null;
  sentAt?: Date | null;
  signedAt?: Date | null;
  signedPdfUrl?: string | null;
  signedPdfPath?: string | null;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
}
